import _regeneratorRuntime from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import axios from 'axios';
import md5 from 'md5';
import _ from 'lodash';
import Debug from 'debug';
import config from '../common/config';
var debug = Debug('shgbit:share:transport');

var TransportLayer =
/*#__PURE__*/
function () {
  function TransportLayer(token) {
    var _this = this;

    _classCallCheck(this, TransportLayer);

    this.token = token;
    var backendOrigin = config.getBackendOrigin();
    this.request = axios.create();
    this.request.interceptors.request.use(function (cfg) {
      cfg.baseURL = 'https://api.space365.net';
      var backend = config.getBackendOrigin();
      if (backend) cfg.baseURL = backend;

      if (_this.token) {
        cfg.headers = _.assign(cfg.headers, {
          Authorization: "Bearer ".concat(_this.token)
        });
      }

      return cfg;
    });
  }
  /**
   * apps operation
   * Hui Cao
   * 2019/7/12
   */


  _createClass(TransportLayer, [{
    key: "updateApp",
    value: function () {
      var _updateApp = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(id, form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.request.post("/apps/".concat(id), form);

              case 2:
                response = _context.sent;
                return _context.abrupt("return", response);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateApp(_x, _x2) {
        return _updateApp.apply(this, arguments);
      }

      return updateApp;
    }()
  }, {
    key: "addApp",
    value: function () {
      var _addApp = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.request.post('/apps/');

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", response);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addApp() {
        return _addApp.apply(this, arguments);
      }

      return addApp;
    }()
  }, {
    key: "deleteApp",
    value: function () {
      var _deleteApp = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.request.delete("/apps/".concat(id));

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", response);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteApp(_x3) {
        return _deleteApp.apply(this, arguments);
      }

      return deleteApp;
    }()
    /**
     * company app rule operation
     * @param company - company id
     * @param app - app code
     * @param {{roles:[String], members:[String]}} form - update data
     */

  }, {
    key: "updateAppRule",
    value: function () {
      var _updateAppRule = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(company, app, form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.request.post("/companies/".concat(company, "/apprules/").concat(app), form);

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", response.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateAppRule(_x4, _x5, _x6) {
        return _updateAppRule.apply(this, arguments);
      }

      return updateAppRule;
    }()
  }, {
    key: "getCurrentUser",
    value: function () {
      var _getCurrentUser = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.request.get('/members/me');

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", response.data);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getCurrentUser() {
        return _getCurrentUser.apply(this, arguments);
      }

      return getCurrentUser;
    }()
  }, {
    key: "getCompanyById",
    value: function () {
      var _getCompanyById = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.request.get("/companies/".concat(id));

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", response.data);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getCompanyById(_x7) {
        return _getCompanyById.apply(this, arguments);
      }

      return getCompanyById;
    }()
  }, {
    key: "getToken",
    value: function () {
      var _getToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(username, password) {
        var response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.request.post('/auth/token', {}, {
                  auth: {
                    username: username,
                    password: password
                  }
                });

              case 2:
                response = _context7.sent;
                this.token = response.data;
                debug('get Token success: ' + this.token);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getToken(_x8, _x9) {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "getTokenWithCompany",
    value: function () {
      var _getTokenWithCompany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(company, username, password) {
        var response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.request.post("/auth/token/".concat(company), {}, {
                  auth: {
                    username: username,
                    password: password
                  }
                });

              case 2:
                response = _context8.sent;
                this.token = response.data;
                debug('get Token success: ' + this.token);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getTokenWithCompany(_x10, _x11, _x12) {
        return _getTokenWithCompany.apply(this, arguments);
      }

      return getTokenWithCompany;
    }()
  }, {
    key: "getTokenByMobile",
    value: function () {
      var _getTokenByMobile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(mobile, pin, companyCode) {
        var response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.request.post("/auth/token/".concat(companyCode), {}, {
                  auth: {
                    username: mobile,
                    password: pin
                  }
                });

              case 2:
                response = _context9.sent;
                this.token = response.data;
                debug('get Token success: ' + this.token);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getTokenByMobile(_x13, _x14, _x15) {
        return _getTokenByMobile.apply(this, arguments);
      }

      return getTokenByMobile;
    }()
  }, {
    key: "getTokenByDingtalk",
    value: function () {
      var _getTokenByDingtalk = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(company, code) {
        var response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.request.post("/auth/ding/token/".concat(company, "?code=").concat(code));

              case 2:
                response = _context10.sent;
                this.token = response.data;
                debug('get Token success: ' + this.token);

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getTokenByDingtalk(_x16, _x17) {
        return _getTokenByDingtalk.apply(this, arguments);
      }

      return getTokenByDingtalk;
    }()
  }, {
    key: "checkRoom",
    value: function () {
      var _checkRoom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(company, room) {
        var result, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                result = null;
                _context11.prev = 1;
                _context11.next = 4;
                return this.request.get("/check/room?company=".concat(company, "&room=").concat(room));

              case 4:
                response = _context11.sent;
                result = response.data;
                _context11.next = 10;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](1);

              case 10:
                return _context11.abrupt("return", result);

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[1, 8]]);
      }));

      function checkRoom(_x18, _x19) {
        return _checkRoom.apply(this, arguments);
      }

      return checkRoom;
    }()
  }, {
    key: "checkAsset",
    value: function () {
      var _checkAsset = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(company, asset) {
        var result, response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                result = null;
                _context12.prev = 1;
                _context12.next = 4;
                return this.request.get("/check/asset?company=".concat(company, "&asset=").concat(asset));

              case 4:
                response = _context12.sent;
                result = response.data;
                _context12.next = 10;
                break;

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12["catch"](1);

              case 10:
                return _context12.abrupt("return", result);

              case 11:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[1, 8]]);
      }));

      function checkAsset(_x20, _x21) {
        return _checkAsset.apply(this, arguments);
      }

      return checkAsset;
    }()
  }, {
    key: "whoami",
    value: function () {
      var _whoami = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.request.get('/whoami');

              case 2:
                response = _context13.sent;
                return _context13.abrupt("return", response.data);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function whoami() {
        return _whoami.apply(this, arguments);
      }

      return whoami;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(email) {
        var response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.request.post("/resetPassword?email=".concat(email));

              case 2:
                response = _context14.sent;
                return _context14.abrupt("return", response.data);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function resetPassword(_x22) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: "fetchNotices",
    value: function () {
      var _fetchNotices = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.request.get("/members/".concat(id, "/notices"));

              case 2:
                response = _context15.sent;
                return _context15.abrupt("return", response.data);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function fetchNotices(_x23) {
        return _fetchNotices.apply(this, arguments);
      }

      return fetchNotices;
    }()
  }, {
    key: "fetchUnreadNotices",
    value: function () {
      var _fetchUnreadNotices = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.request.get("/members/".concat(id, "/notices/unread"));

              case 2:
                response = _context16.sent;
                return _context16.abrupt("return", response.data);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function fetchUnreadNotices(_x24) {
        return _fetchUnreadNotices.apply(this, arguments);
      }

      return fetchUnreadNotices;
    }()
  }, {
    key: "updateNotice",
    value: function () {
      var _updateNotice = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17(json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.request.post("/notices/".concat(json.id), json);

              case 2:
                response = _context17.sent;
                return _context17.abrupt("return", response.data);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function updateNotice(_x25) {
        return _updateNotice.apply(this, arguments);
      }

      return updateNotice;
    }()
  }, {
    key: "clearAllNotices",
    value: function () {
      var _clearAllNotices = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.request.post("/members/".concat(id, "/notices/clear"));

              case 2:
                response = _context18.sent;
                return _context18.abrupt("return", response.data);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function clearAllNotices(_x26) {
        return _clearAllNotices.apply(this, arguments);
      }

      return clearAllNotices;
    }()
  }, {
    key: "readAllNotices",
    value: function () {
      var _readAllNotices = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.request.post("/members/".concat(id, "/notices/read"));

              case 2:
                response = _context19.sent;
                return _context19.abrupt("return", response.data);

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function readAllNotices(_x27) {
        return _readAllNotices.apply(this, arguments);
      }

      return readAllNotices;
    }() // device

  }, {
    key: "getDeivceTypes",
    value: function () {
      var _getDeivceTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20() {
        var response;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.request.get('/devices/types');

              case 2:
                response = _context20.sent;
                return _context20.abrupt("return", response.data);

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getDeivceTypes() {
        return _getDeivceTypes.apply(this, arguments);
      }

      return getDeivceTypes;
    }()
  }, {
    key: "DeviceSend",
    value: function () {
      var _DeviceSend = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21(json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.request.post('/devices/send', json);

              case 2:
                response = _context21.sent;
                return _context21.abrupt("return", response.data);

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function DeviceSend(_x28) {
        return _DeviceSend.apply(this, arguments);
      }

      return DeviceSend;
    }() // qrcode

  }, {
    key: "fetchQRCode",
    value: function () {
      var _fetchQRCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.request.get("/qrcode/".concat(id));

              case 2:
                response = _context22.sent;
                return _context22.abrupt("return", response.data);

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function fetchQRCode(_x29) {
        return _fetchQRCode.apply(this, arguments);
      }

      return fetchQRCode;
    }()
  }, {
    key: "fetchQRCodes",
    value: function () {
      var _fetchQRCodes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        var response;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.request.get('/qrcode');

              case 2:
                response = _context23.sent;
                return _context23.abrupt("return", response.data);

              case 4:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function fetchQRCodes() {
        return _fetchQRCodes.apply(this, arguments);
      }

      return fetchQRCodes;
    }()
  }, {
    key: "fetchQRCodesByCode",
    value: function () {
      var _fetchQRCodesByCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24(code) {
        var response;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this.request.get("/qrcode/code/".concat(code));

              case 2:
                response = _context24.sent;
                return _context24.abrupt("return", response.data);

              case 4:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function fetchQRCodesByCode(_x30) {
        return _fetchQRCodesByCode.apply(this, arguments);
      }

      return fetchQRCodesByCode;
    }()
  }, {
    key: "createQRCode",
    value: function () {
      var _createQRCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return this.request.post('/qrcode', form);

              case 2:
                response = _context25.sent;
                return _context25.abrupt("return", response.data);

              case 4:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function createQRCode(_x31) {
        return _createQRCode.apply(this, arguments);
      }

      return createQRCode;
    }()
  }, {
    key: "updateQRCode",
    value: function () {
      var _updateQRCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26(json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.request.post("/qrcode/".concat(json.id), json);

              case 2:
                response = _context26.sent;
                return _context26.abrupt("return", response.data);

              case 4:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function updateQRCode(_x32) {
        return _updateQRCode.apply(this, arguments);
      }

      return updateQRCode;
    }()
  }, {
    key: "deleteQRCode",
    value: function () {
      var _deleteQRCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27(id) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.request.delete("/qrcode/".concat(id));

              case 2:
                return _context27.abrupt("return", _context27.sent);

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function deleteQRCode(_x33) {
        return _deleteQRCode.apply(this, arguments);
      }

      return deleteQRCode;
    }() // member

  }, {
    key: "fetchMember",
    value: function () {
      var _fetchMember = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.request.get("/members/".concat(id));

              case 2:
                response = _context28.sent;
                return _context28.abrupt("return", response.data);

              case 4:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function fetchMember(_x34) {
        return _fetchMember.apply(this, arguments);
      }

      return fetchMember;
    }()
  }, {
    key: "fetchMemberbyCode",
    value: function () {
      var _fetchMemberbyCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29(code) {
        var response;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.request.get("/members/code/".concat(code));

              case 2:
                response = _context29.sent;
                return _context29.abrupt("return", response.data);

              case 4:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function fetchMemberbyCode(_x35) {
        return _fetchMemberbyCode.apply(this, arguments);
      }

      return fetchMemberbyCode;
    }()
  }, {
    key: "fetchMemberByDepartment",
    value: function () {
      var _fetchMemberByDepartment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30(deptCode) {
        var response;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.request.get("/members/department/".concat(deptCode));

              case 2:
                response = _context30.sent;
                return _context30.abrupt("return", response.data);

              case 4:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function fetchMemberByDepartment(_x36) {
        return _fetchMemberByDepartment.apply(this, arguments);
      }

      return fetchMemberByDepartment;
    }()
  }, {
    key: "fetchAllMembers",
    value: function () {
      var _fetchAllMembers = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee31() {
        var response;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.request.get('/members/allMembers');

              case 2:
                response = _context31.sent;
                return _context31.abrupt("return", response.data);

              case 4:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function fetchAllMembers() {
        return _fetchAllMembers.apply(this, arguments);
      }

      return fetchAllMembers;
    }()
  }, {
    key: "fetchMembers",
    value: function () {
      var _fetchMembers = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee32() {
        var response;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return this.request.get('/members');

              case 2:
                response = _context32.sent;
                return _context32.abrupt("return", response.data);

              case 4:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function fetchMembers() {
        return _fetchMembers.apply(this, arguments);
      }

      return fetchMembers;
    }()
  }, {
    key: "createMember",
    value: function () {
      var _createMember = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee33(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return this.request.post('/members', form);

              case 2:
                response = _context33.sent;
                return _context33.abrupt("return", response.data);

              case 4:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function createMember(_x37) {
        return _createMember.apply(this, arguments);
      }

      return createMember;
    }()
  }, {
    key: "updateMember",
    value: function () {
      var _updateMember = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee34(json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return this.request.post("/members/".concat(json.id), json);

              case 2:
                response = _context34.sent;
                return _context34.abrupt("return", response.data);

              case 4:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function updateMember(_x38) {
        return _updateMember.apply(this, arguments);
      }

      return updateMember;
    }()
  }, {
    key: "deleteMember",
    value: function () {
      var _deleteMember = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee35(id) {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return this.request.delete("/members/".concat(id));

              case 2:
                return _context35.abrupt("return", _context35.sent);

              case 3:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function deleteMember(_x39) {
        return _deleteMember.apply(this, arguments);
      }

      return deleteMember;
    }() // room

  }, {
    key: "fetchRoomsByCompany",
    value: function () {
      var _fetchRoomsByCompany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee36(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return this.request.get("/companies/".concat(id, "/rooms"));

              case 2:
                response = _context36.sent;
                return _context36.abrupt("return", response.data);

              case 4:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function fetchRoomsByCompany(_x40) {
        return _fetchRoomsByCompany.apply(this, arguments);
      }

      return fetchRoomsByCompany;
    }()
  }, {
    key: "fetchRooms",
    value: function () {
      var _fetchRooms = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee37() {
        var response;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return this.request.get('/rooms');

              case 2:
                response = _context37.sent;
                return _context37.abrupt("return", response.data);

              case 4:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function fetchRooms() {
        return _fetchRooms.apply(this, arguments);
      }

      return fetchRooms;
    }()
  }, {
    key: "fetchSystemLayout",
    value: function () {
      var _fetchSystemLayout = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee38() {
        var response;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return this.request.get('/rooms/systemLayout');

              case 2:
                response = _context38.sent;
                return _context38.abrupt("return", response.data);

              case 4:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function fetchSystemLayout() {
        return _fetchSystemLayout.apply(this, arguments);
      }

      return fetchSystemLayout;
    }()
  }, {
    key: "fetchAllRooms",
    value: function () {
      var _fetchAllRooms = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee39() {
        var response;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return this.request.get('/rooms/allRooms');

              case 2:
                response = _context39.sent;
                return _context39.abrupt("return", response.data);

              case 4:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function fetchAllRooms() {
        return _fetchAllRooms.apply(this, arguments);
      }

      return fetchAllRooms;
    }()
  }, {
    key: "fetchRoom",
    value: function () {
      var _fetchRoom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee40(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.next = 2;
                return this.request.get("/rooms/".concat(id));

              case 2:
                response = _context40.sent;
                return _context40.abrupt("return", response.data);

              case 4:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function fetchRoom(_x41) {
        return _fetchRoom.apply(this, arguments);
      }

      return fetchRoom;
    }()
  }, {
    key: "fetchRoomByArea",
    value: function () {
      var _fetchRoomByArea = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee41(areaCode) {
        var response;
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.next = 2;
                return this.request.get("/rooms/area/".concat(areaCode));

              case 2:
                response = _context41.sent;
                return _context41.abrupt("return", response.data);

              case 4:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function fetchRoomByArea(_x42) {
        return _fetchRoomByArea.apply(this, arguments);
      }

      return fetchRoomByArea;
    }()
  }, {
    key: "fetchRoomByCode",
    value: function () {
      var _fetchRoomByCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee42(code) {
        var response;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                _context42.next = 2;
                return this.request.get("/rooms/code/".concat(code));

              case 2:
                response = _context42.sent;
                return _context42.abrupt("return", response.data);

              case 4:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function fetchRoomByCode(_x43) {
        return _fetchRoomByCode.apply(this, arguments);
      }

      return fetchRoomByCode;
    }()
  }, {
    key: "fetchAsset",
    value: function () {
      var _fetchAsset = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee43(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return this.request.get("/assets/".concat(id));

              case 2:
                response = _context43.sent;
                return _context43.abrupt("return", response.data);

              case 4:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function fetchAsset(_x44) {
        return _fetchAsset.apply(this, arguments);
      }

      return fetchAsset;
    }()
  }, {
    key: "createRoom",
    value: function () {
      var _createRoom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee44(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.next = 2;
                return this.request.post('/rooms', form);

              case 2:
                response = _context44.sent;
                return _context44.abrupt("return", response.data);

              case 4:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function createRoom(_x45) {
        return _createRoom.apply(this, arguments);
      }

      return createRoom;
    }()
  }, {
    key: "updateRoom",
    value: function () {
      var _updateRoom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee45(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return this.request.post("/rooms/".concat(form.id), form);

              case 2:
                response = _context45.sent;
                return _context45.abrupt("return", response.data);

              case 4:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function updateRoom(_x46) {
        return _updateRoom.apply(this, arguments);
      }

      return updateRoom;
    }()
  }, {
    key: "deleteRoom",
    value: function () {
      var _deleteRoom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee46(id) {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.next = 2;
                return this.request.delete("/rooms/".concat(id));

              case 2:
                return _context46.abrupt("return", _context46.sent);

              case 3:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function deleteRoom(_x47) {
        return _deleteRoom.apply(this, arguments);
      }

      return deleteRoom;
    }() // company

  }, {
    key: "createCompany",
    value: function () {
      var _createCompany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee47(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.next = 2;
                return this.request.post('/companies', form);

              case 2:
                response = _context47.sent;
                return _context47.abrupt("return", response.data);

              case 4:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function createCompany(_x48) {
        return _createCompany.apply(this, arguments);
      }

      return createCompany;
    }()
  }, {
    key: "fetchCompanies",
    value: function () {
      var _fetchCompanies = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee48() {
        var response;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                _context48.next = 2;
                return this.request.get('/companies');

              case 2:
                response = _context48.sent;
                return _context48.abrupt("return", response.data);

              case 4:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function fetchCompanies() {
        return _fetchCompanies.apply(this, arguments);
      }

      return fetchCompanies;
    }()
  }, {
    key: "fetchCompany",
    value: function () {
      var _fetchCompany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee49(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _context49.next = 2;
                return this.request.get("/companies/".concat(id));

              case 2:
                response = _context49.sent;
                return _context49.abrupt("return", response.data);

              case 4:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function fetchCompany(_x49) {
        return _fetchCompany.apply(this, arguments);
      }

      return fetchCompany;
    }()
  }, {
    key: "updateCompany",
    value: function () {
      var _updateCompany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee50(json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.next = 2;
                return this.request.post("/companies/".concat(json.id), json);

              case 2:
                response = _context50.sent;
                return _context50.abrupt("return", response.data);

              case 4:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function updateCompany(_x50) {
        return _updateCompany.apply(this, arguments);
      }

      return updateCompany;
    }()
  }, {
    key: "deleteCompany",
    value: function () {
      var _deleteCompany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee51(id) {
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                _context51.next = 2;
                return this.request.delete("/companies/".concat(id));

              case 2:
                return _context51.abrupt("return", _context51.sent);

              case 3:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function deleteCompany(_x51) {
        return _deleteCompany.apply(this, arguments);
      }

      return deleteCompany;
    }()
  }, {
    key: "syncMemberDepartment",
    value: function () {
      var _syncMemberDepartment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee52(id) {
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                _context52.next = 2;
                return this.request.post("/companies/".concat(id, "/sync"), null);

              case 2:
                return _context52.abrupt("return", _context52.sent);

              case 3:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));

      function syncMemberDepartment(_x52) {
        return _syncMemberDepartment.apply(this, arguments);
      }

      return syncMemberDepartment;
    }()
  }, {
    key: "syncMeetings",
    value: function () {
      var _syncMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee53(id) {
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.next = 2;
                return this.request.post("/companies/".concat(id, "/syncMeetings"), null);

              case 2:
                return _context53.abrupt("return", _context53.sent);

              case 3:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));

      function syncMeetings(_x53) {
        return _syncMeetings.apply(this, arguments);
      }

      return syncMeetings;
    }() // meeting

  }, {
    key: "findAllMeetings",
    value: function () {
      var _findAllMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee54() {
        var response;
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _context54.next = 2;
                return this.request.get('/meetings/allMeetings');

              case 2:
                response = _context54.sent;
                return _context54.abrupt("return", response.data);

              case 4:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));

      function findAllMeetings() {
        return _findAllMeetings.apply(this, arguments);
      }

      return findAllMeetings;
    }()
  }, {
    key: "createMeeting",
    value: function () {
      var _createMeeting = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee55(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                _context55.next = 2;
                return this.request.post('/meetings', form);

              case 2:
                response = _context55.sent;
                return _context55.abrupt("return", response.data);

              case 4:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function createMeeting(_x54) {
        return _createMeeting.apply(this, arguments);
      }

      return createMeeting;
    }()
  }, {
    key: "fetchMeeting",
    value: function () {
      var _fetchMeeting = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee56(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                _context56.next = 2;
                return this.request.get("/meetings/".concat(id));

              case 2:
                response = _context56.sent;
                return _context56.abrupt("return", response.data);

              case 4:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));

      function fetchMeeting(_x55) {
        return _fetchMeeting.apply(this, arguments);
      }

      return fetchMeeting;
    }()
  }, {
    key: "fetchMeetingsByCompany",
    value: function () {
      var _fetchMeetingsByCompany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee57(companyId, begin, end) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                url = "/companies/".concat(companyId, "/meetings");

                if (begin) {
                  url += "?begin=".concat(begin.unix());

                  if (end) {
                    url += "&end=".concat(end.unix());
                  }
                }

                _context57.next = 4;
                return this.request.get(url);

              case 4:
                response = _context57.sent;
                return _context57.abrupt("return", response.data);

              case 6:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));

      function fetchMeetingsByCompany(_x56, _x57, _x58) {
        return _fetchMeetingsByCompany.apply(this, arguments);
      }

      return fetchMeetingsByCompany;
    }()
  }, {
    key: "fetchMeetingsByRoom",
    value: function () {
      var _fetchMeetingsByRoom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee58(id, begin, end) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                url = "/rooms/".concat(id, "/meetings");

                if (begin) {
                  url += "?begin=".concat(begin.unix());

                  if (end) {
                    url += "&end=".concat(end.unix());
                  }
                }

                _context58.next = 4;
                return this.request.get(url);

              case 4:
                response = _context58.sent;
                return _context58.abrupt("return", response.data);

              case 6:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));

      function fetchMeetingsByRoom(_x59, _x60, _x61) {
        return _fetchMeetingsByRoom.apply(this, arguments);
      }

      return fetchMeetingsByRoom;
    }()
  }, {
    key: "fetchMyMeetings",
    value: function () {
      var _fetchMyMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee59(member) {
        var response;
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.next = 2;
                return this.request.get("/members/".concat(member.id, "/meetings"));

              case 2:
                response = _context59.sent;
                return _context59.abrupt("return", response.data);

              case 4:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));

      function fetchMyMeetings(_x62) {
        return _fetchMyMeetings.apply(this, arguments);
      }

      return fetchMyMeetings;
    }()
  }, {
    key: "fetchMyAuditMeetings",
    value: function () {
      var _fetchMyAuditMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee60(member) {
        var response;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return this.request.get("/members/".concat(member.id, "/auditMeetings"));

              case 2:
                response = _context60.sent;
                return _context60.abrupt("return", response.data);

              case 4:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function fetchMyAuditMeetings(_x63) {
        return _fetchMyAuditMeetings.apply(this, arguments);
      }

      return fetchMyAuditMeetings;
    }()
  }, {
    key: "fetchMyParticipateMeetings",
    value: function () {
      var _fetchMyParticipateMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee61(member) {
        var response;
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.next = 2;
                return this.request.get("/members/".concat(member.id, "/participateMeetings"));

              case 2:
                response = _context61.sent;
                return _context61.abrupt("return", response.data);

              case 4:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));

      function fetchMyParticipateMeetings(_x64) {
        return _fetchMyParticipateMeetings.apply(this, arguments);
      }

      return fetchMyParticipateMeetings;
    }()
  }, {
    key: "fetchAllUsers",
    value: function () {
      var _fetchAllUsers = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee62(company, vcType) {
        var response;
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.next = 2;
                return this.request.get("/companies/".concat(company.id, "/vc/users/").concat(vcType));

              case 2:
                response = _context62.sent;
                return _context62.abrupt("return", response.data);

              case 4:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));

      function fetchAllUsers(_x65, _x66) {
        return _fetchAllUsers.apply(this, arguments);
      }

      return fetchAllUsers;
    }()
  }, {
    key: "fetchAllDeviceTypes",
    value: function () {
      var _fetchAllDeviceTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee63(company) {
        var response;
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                _context63.next = 2;
                return this.request.get('/devices/types');

              case 2:
                response = _context63.sent;
                return _context63.abrupt("return", response.data);

              case 4:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function fetchAllDeviceTypes(_x67) {
        return _fetchAllDeviceTypes.apply(this, arguments);
      }

      return fetchAllDeviceTypes;
    }()
  }, {
    key: "fetchCurrentVCMeetings",
    value: function () {
      var _fetchCurrentVCMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee64(company, vcType) {
        var response;
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.next = 2;
                return this.request.get("/companies/".concat(company.id, "/vc/currentMeetings/").concat(vcType));

              case 2:
                response = _context64.sent;
                return _context64.abrupt("return", response.data);

              case 4:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function fetchCurrentVCMeetings(_x68, _x69) {
        return _fetchCurrentVCMeetings.apply(this, arguments);
      }

      return fetchCurrentVCMeetings;
    }()
  }, {
    key: "fetchReadyVCMeetings",
    value: function () {
      var _fetchReadyVCMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee65(company, vcType, from, to) {
        var response;
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                _context65.next = 2;
                return this.request.get("/companies/".concat(company.id, "/vc/readyMeetings/").concat(vcType, "/").concat(from, "/").concat(to));

              case 2:
                response = _context65.sent;
                return _context65.abrupt("return", response.data);

              case 4:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));

      function fetchReadyVCMeetings(_x70, _x71, _x72, _x73) {
        return _fetchReadyVCMeetings.apply(this, arguments);
      }

      return fetchReadyVCMeetings;
    }()
  }, {
    key: "fetchClosedVCMeetings",
    value: function () {
      var _fetchClosedVCMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee66(company, vcType, from, to) {
        var response;
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                _context66.next = 2;
                return this.request.get("/companies/".concat(company.id, "/vc/closedMeetings/").concat(vcType, "/").concat(from, "/").concat(to));

              case 2:
                response = _context66.sent;
                return _context66.abrupt("return", response.data);

              case 4:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function fetchClosedVCMeetings(_x74, _x75, _x76, _x77) {
        return _fetchClosedVCMeetings.apply(this, arguments);
      }

      return fetchClosedVCMeetings;
    }()
  }, {
    key: "fetchStartRecordMeetings",
    value: function () {
      var _fetchStartRecordMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee67(company, vcType, vc) {
        var response;
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                _context67.next = 2;
                return this.request.post("/companies/".concat(company.id, "/vc/recording/start"), vc);

              case 2:
                response = _context67.sent;
                return _context67.abrupt("return", response.data);

              case 4:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));

      function fetchStartRecordMeetings(_x78, _x79, _x80) {
        return _fetchStartRecordMeetings.apply(this, arguments);
      }

      return fetchStartRecordMeetings;
    }()
  }, {
    key: "fetchStopRecordMeetings",
    value: function () {
      var _fetchStopRecordMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee68(company, vcType, vc) {
        var response;
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                _context68.next = 2;
                return this.request.post("/companies/".concat(company.id, "/vc/recording/stop"), vc);

              case 2:
                response = _context68.sent;
                return _context68.abrupt("return", response.data);

              case 4:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));

      function fetchStopRecordMeetings(_x81, _x82, _x83) {
        return _fetchStopRecordMeetings.apply(this, arguments);
      }

      return fetchStopRecordMeetings;
    }()
  }, {
    key: "fetchLockMeetings",
    value: function () {
      var _fetchLockMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee69(company, vcType, vc) {
        var response;
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                _context69.next = 2;
                return this.request.post("/companies/".concat(company.id, "/vc/lock"), vc);

              case 2:
                response = _context69.sent;
                return _context69.abrupt("return", response.data);

              case 4:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));

      function fetchLockMeetings(_x84, _x85, _x86) {
        return _fetchLockMeetings.apply(this, arguments);
      }

      return fetchLockMeetings;
    }()
  }, {
    key: "fetchUnLockMeetings",
    value: function () {
      var _fetchUnLockMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee70(company, vcType, vc) {
        var response;
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                _context70.next = 2;
                return this.request.post("/companies/".concat(company.id, "/vc/unlock"), vc);

              case 2:
                response = _context70.sent;
                return _context70.abrupt("return", response.data);

              case 4:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));

      function fetchUnLockMeetings(_x87, _x88, _x89) {
        return _fetchUnLockMeetings.apply(this, arguments);
      }

      return fetchUnLockMeetings;
    }()
  }, {
    key: "fetchMuteMeetings",
    value: function () {
      var _fetchMuteMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee71(company, vcType, vc, memberId) {
        var response;
        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                _context71.next = 2;
                return this.request.post("/companies/".concat(company.id, "/vc/mute/").concat(memberId), vc);

              case 2:
                response = _context71.sent;
                return _context71.abrupt("return", response.data);

              case 4:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this);
      }));

      function fetchMuteMeetings(_x90, _x91, _x92, _x93) {
        return _fetchMuteMeetings.apply(this, arguments);
      }

      return fetchMuteMeetings;
    }()
  }, {
    key: "fetchUnMuteMeetings",
    value: function () {
      var _fetchUnMuteMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee72(company, vcType, vc, memberId) {
        var response;
        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                _context72.next = 2;
                return this.request.post("/companies/".concat(company.id, "/vc/unmute/").concat(memberId), vc);

              case 2:
                response = _context72.sent;
                return _context72.abrupt("return", response.data);

              case 4:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, this);
      }));

      function fetchUnMuteMeetings(_x94, _x95, _x96, _x97) {
        return _fetchUnMuteMeetings.apply(this, arguments);
      }

      return fetchUnMuteMeetings;
    }()
  }, {
    key: "fetchInviteMember",
    value: function () {
      var _fetchInviteMember = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee73(company, vcType, vc, memberId) {
        var response;
        return _regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                _context73.next = 2;
                return this.request.post("/companies/".concat(company.id, "/vc/invite/").concat(memberId), vc);

              case 2:
                response = _context73.sent;
                return _context73.abrupt("return", response.data);

              case 4:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73, this);
      }));

      function fetchInviteMember(_x98, _x99, _x100, _x101) {
        return _fetchInviteMember.apply(this, arguments);
      }

      return fetchInviteMember;
    }()
  }, {
    key: "fetchRemoveMember",
    value: function () {
      var _fetchRemoveMember = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee74(company, vcType, vc, memberId) {
        var response;
        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                _context74.next = 2;
                return this.request.post("/companies/".concat(company.id, "/vc/kick/").concat(memberId), vc);

              case 2:
                response = _context74.sent;
                return _context74.abrupt("return", response.data);

              case 4:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, this);
      }));

      function fetchRemoveMember(_x102, _x103, _x104, _x105) {
        return _fetchRemoveMember.apply(this, arguments);
      }

      return fetchRemoveMember;
    }()
  }, {
    key: "updateMeeting",
    value: function () {
      var _updateMeeting = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee75(json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                _context75.next = 2;
                return this.request.post("/meetings/".concat(json.id), json);

              case 2:
                response = _context75.sent;
                return _context75.abrupt("return", response.data);

              case 4:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75, this);
      }));

      function updateMeeting(_x106) {
        return _updateMeeting.apply(this, arguments);
      }

      return updateMeeting;
    }()
  }, {
    key: "cancelMeeting",
    value: function () {
      var _cancelMeeting = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee76(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                _context76.next = 2;
                return this.request.post("/meetings/".concat(id, "/cancel"), null);

              case 2:
                response = _context76.sent;
                return _context76.abrupt("return", response.data);

              case 4:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, this);
      }));

      function cancelMeeting(_x107) {
        return _cancelMeeting.apply(this, arguments);
      }

      return cancelMeeting;
    }()
  }, {
    key: "cancelRepeatMeeting",
    value: function () {
      var _cancelRepeatMeeting = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee77(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                _context77.next = 2;
                return this.request.post("/meetings/repeat/".concat(id, "/cancel"), null);

              case 2:
                response = _context77.sent;
                return _context77.abrupt("return", response.data);

              case 4:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this);
      }));

      function cancelRepeatMeeting(_x108) {
        return _cancelRepeatMeeting.apply(this, arguments);
      }

      return cancelRepeatMeeting;
    }()
  }, {
    key: "deleteMeeting",
    value: function () {
      var _deleteMeeting = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee78(id) {
        return _regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                _context78.next = 2;
                return this.request.delete("/meetings/".concat(id));

              case 2:
                return _context78.abrupt("return", _context78.sent);

              case 3:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78, this);
      }));

      function deleteMeeting(_x109) {
        return _deleteMeeting.apply(this, arguments);
      }

      return deleteMeeting;
    }()
  }, {
    key: "deleteRepeatMeetings",
    value: function () {
      var _deleteRepeatMeetings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee79(id) {
        return _regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                _context79.next = 2;
                return this.request.delete("/meetings/repeat/".concat(id));

              case 2:
                return _context79.abrupt("return", _context79.sent);

              case 3:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee79, this);
      }));

      function deleteRepeatMeetings(_x110) {
        return _deleteRepeatMeetings.apply(this, arguments);
      }

      return deleteRepeatMeetings;
    }()
  }, {
    key: "finishedMeeting",
    value: function () {
      var _finishedMeeting = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee80(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                _context80.next = 2;
                return this.request.post("/meetings/".concat(id, "/finished"), null);

              case 2:
                response = _context80.sent;
                return _context80.abrupt("return", response.data);

              case 4:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80, this);
      }));

      function finishedMeeting(_x111) {
        return _finishedMeeting.apply(this, arguments);
      }

      return finishedMeeting;
    }() // id: meeting id

  }, {
    key: "sendInvitationByEmail",
    value: function () {
      var _sendInvitationByEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee81(id, data, email) {
        var response;
        return _regeneratorRuntime.wrap(function _callee81$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                if (!email) {
                  _context81.next = 6;
                  break;
                }

                _context81.next = 3;
                return this.request.post("/meetings/".concat(id, "/invitation/email/").concat(email), data);

              case 3:
                response = _context81.sent;
                _context81.next = 9;
                break;

              case 6:
                _context81.next = 8;
                return this.request.post("/meetings/".concat(id, "/invitation/email"), data);

              case 8:
                response = _context81.sent;

              case 9:
                return _context81.abrupt("return", response.data);

              case 10:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee81, this);
      }));

      function sendInvitationByEmail(_x112, _x113, _x114) {
        return _sendInvitationByEmail.apply(this, arguments);
      }

      return sendInvitationByEmail;
    }()
  }, {
    key: "sendInvitationBySms",
    value: function () {
      var _sendInvitationBySms = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee82(id, data, mobile) {
        var response;
        return _regeneratorRuntime.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                if (!mobile) {
                  _context82.next = 6;
                  break;
                }

                _context82.next = 3;
                return this.request.post("/meetings/".concat(id, "/invitation/sms/").concat(mobile), data);

              case 3:
                response = _context82.sent;
                _context82.next = 9;
                break;

              case 6:
                _context82.next = 8;
                return this.request.post("/meetings/".concat(id, "/invitation/sms"), data);

              case 8:
                response = _context82.sent;

              case 9:
                return _context82.abrupt("return", response.data);

              case 10:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82, this);
      }));

      function sendInvitationBySms(_x115, _x116, _x117) {
        return _sendInvitationBySms.apply(this, arguments);
      }

      return sendInvitationBySms;
    }() // logs

  }, {
    key: "fetchLogs",
    value: function () {
      var _fetchLogs = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee83(company, begin, end) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                url = "/companies/".concat(company.id, "/logs");

                if (begin) {
                  url += "?begin=".concat(begin.unix());

                  if (end) {
                    url += "&end=".concat(end.unix());
                  }
                }

                _context83.next = 4;
                return this.request.get(url);

              case 4:
                response = _context83.sent;
                return _context83.abrupt("return", response.data);

              case 6:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83, this);
      }));

      function fetchLogs(_x118, _x119, _x120) {
        return _fetchLogs.apply(this, arguments);
      }

      return fetchLogs;
    }()
  }, {
    key: "fetchMemberLogs",
    value: function () {
      var _fetchMemberLogs = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee84(id, tag) {
        var response;
        return _regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                _context84.next = 2;
                return this.request.get("/logs/".concat(id, "/").concat(tag));

              case 2:
                response = _context84.sent;
                return _context84.abrupt("return", response.data);

              case 4:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84, this);
      }));

      function fetchMemberLogs(_x121, _x122) {
        return _fetchMemberLogs.apply(this, arguments);
      }

      return fetchMemberLogs;
    }() // tasks

  }, {
    key: "fetchTasks",
    value: function () {
      var _fetchTasks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee85(member) {
        var response;
        return _regeneratorRuntime.wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                _context85.next = 2;
                return this.request.get("/members/".concat(member.id, "/tasks"));

              case 2:
                response = _context85.sent;
                return _context85.abrupt("return", response.data);

              case 4:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85, this);
      }));

      function fetchTasks(_x123) {
        return _fetchTasks.apply(this, arguments);
      }

      return fetchTasks;
    }()
  }, {
    key: "updateTask",
    value: function () {
      var _updateTask = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee86(json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                _context86.next = 2;
                return this.request.post("/tasks/".concat(json.id), json);

              case 2:
                response = _context86.sent;
                return _context86.abrupt("return", response.data);

              case 4:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86, this);
      }));

      function updateTask(_x124) {
        return _updateTask.apply(this, arguments);
      }

      return updateTask;
    }()
  }, {
    key: "sendSmsPin",
    value: function () {
      var _sendSmsPin = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee87(mobile, pin) {
        var response;
        return _regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                _context87.next = 2;
                return this.request.post("/sms/pin/".concat(mobile, "/").concat(pin), {}, {
                  headers: {
                    secret: md5(mobile + pin),
                    from: 'phone'
                  }
                });

              case 2:
                response = _context87.sent;
                return _context87.abrupt("return", response.data);

              case 4:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87, this);
      }));

      function sendSmsPin(_x125, _x126) {
        return _sendSmsPin.apply(this, arguments);
      }

      return sendSmsPin;
    }()
  }, {
    key: "sendSmsRegister",
    value: function () {
      var _sendSmsRegister = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee88(mobile, pin) {
        var response;
        return _regeneratorRuntime.wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                _context88.next = 2;
                return this.request.post("/sms/register/".concat(mobile, "/").concat(pin), {}, {
                  headers: {
                    secret: md5(mobile + pin),
                    from: 'phone'
                  }
                });

              case 2:
                response = _context88.sent;
                return _context88.abrupt("return", response.data);

              case 4:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88, this);
      }));

      function sendSmsRegister(_x127, _x128) {
        return _sendSmsRegister.apply(this, arguments);
      }

      return sendSmsRegister;
    }()
  }, {
    key: "fetchRepair",
    value: function () {
      var _fetchRepair = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee89(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                _context89.next = 2;
                return this.request.get("/repairs/".concat(id));

              case 2:
                response = _context89.sent;
                return _context89.abrupt("return", response.data);

              case 4:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89, this);
      }));

      function fetchRepair(_x129) {
        return _fetchRepair.apply(this, arguments);
      }

      return fetchRepair;
    }()
  }, {
    key: "createRepair",
    value: function () {
      var _createRepair = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee90(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                _context90.next = 2;
                return this.request.post('/repairs', form);

              case 2:
                response = _context90.sent;
                return _context90.abrupt("return", response.data);

              case 4:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90, this);
      }));

      function createRepair(_x130) {
        return _createRepair.apply(this, arguments);
      }

      return createRepair;
    }()
  }, {
    key: "updateRepair",
    value: function () {
      var _updateRepair = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee91(json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                _context91.next = 2;
                return this.request.post("/repairs/".concat(json.id), json);

              case 2:
                response = _context91.sent;
                return _context91.abrupt("return", response.data);

              case 4:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91, this);
      }));

      function updateRepair(_x131) {
        return _updateRepair.apply(this, arguments);
      }

      return updateRepair;
    }() // repairs

  }, {
    key: "fetchRepairsByCompany",
    value: function () {
      var _fetchRepairsByCompany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee92(company, begin, end) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                url = "/companies/".concat(company._id, "/repairs");

                if (begin) {
                  url += "?begin=".concat(begin.unix());
                }

                if (end) {
                  url += "&end=".concat(end.unix());
                }

                _context92.next = 5;
                return this.request.get(url);

              case 5:
                response = _context92.sent;
                return _context92.abrupt("return", response.data);

              case 7:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, this);
      }));

      function fetchRepairsByCompany(_x132, _x133, _x134) {
        return _fetchRepairsByCompany.apply(this, arguments);
      }

      return fetchRepairsByCompany;
    }()
  }, {
    key: "fetchRepairsByOwner",
    value: function () {
      var _fetchRepairsByOwner = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee93(member) {
        var response;
        return _regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                _context93.next = 2;
                return this.request.get("/members/".concat(member.id, "/repairs"));

              case 2:
                response = _context93.sent;
                return _context93.abrupt("return", response.data);

              case 4:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, this);
      }));

      function fetchRepairsByOwner(_x135) {
        return _fetchRepairsByOwner.apply(this, arguments);
      }

      return fetchRepairsByOwner;
    }()
  }, {
    key: "fetchRepairsByRuleMember",
    value: function () {
      var _fetchRepairsByRuleMember = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee94(member) {
        var response;
        return _regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                _context94.next = 2;
                return this.request.get("/members/".concat(member.id, "/repairTasks"));

              case 2:
                response = _context94.sent;
                return _context94.abrupt("return", response.data);

              case 4:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, this);
      }));

      function fetchRepairsByRuleMember(_x136) {
        return _fetchRepairsByRuleMember.apply(this, arguments);
      }

      return fetchRepairsByRuleMember;
    }()
  }, {
    key: "fetchWorkflowContexts",
    value: function () {
      var _fetchWorkflowContexts = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee95() {
        var response;
        return _regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                _context95.next = 2;
                return this.request.get('/workflows');

              case 2:
                response = _context95.sent;
                return _context95.abrupt("return", response.data);

              case 4:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, this);
      }));

      function fetchWorkflowContexts() {
        return _fetchWorkflowContexts.apply(this, arguments);
      }

      return fetchWorkflowContexts;
    }()
  }, {
    key: "fetchWorkflowContext",
    value: function () {
      var _fetchWorkflowContext = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee96(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                _context96.next = 2;
                return this.request.get("/workflows/".concat(id));

              case 2:
                response = _context96.sent;
                return _context96.abrupt("return", response.data);

              case 4:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96, this);
      }));

      function fetchWorkflowContext(_x137) {
        return _fetchWorkflowContext.apply(this, arguments);
      }

      return fetchWorkflowContext;
    }()
  }, {
    key: "fetchCustomers",
    value: function () {
      var _fetchCustomers = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee97() {
        var response;
        return _regeneratorRuntime.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                _context97.next = 2;
                return this.request.get('/getCustomers');

              case 2:
                response = _context97.sent;
                return _context97.abrupt("return", response.data);

              case 4:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97, this);
      }));

      function fetchCustomers() {
        return _fetchCustomers.apply(this, arguments);
      }

      return fetchCustomers;
    }()
  }, {
    key: "createWorkflowContext",
    value: function () {
      var _createWorkflowContext = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee98(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee98$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                _context98.next = 2;
                return this.request.post('/workflows', form);

              case 2:
                response = _context98.sent;
                return _context98.abrupt("return", response.data);

              case 4:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee98, this);
      }));

      function createWorkflowContext(_x138) {
        return _createWorkflowContext.apply(this, arguments);
      }

      return createWorkflowContext;
    }()
  }, {
    key: "updateWorkflowContext",
    value: function () {
      var _updateWorkflowContext = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee99(json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee99$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                _context99.next = 2;
                return this.request.post("/workflows/".concat(json.id), json);

              case 2:
                response = _context99.sent;
                return _context99.abrupt("return", response.data);

              case 4:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee99, this);
      }));

      function updateWorkflowContext(_x139) {
        return _updateWorkflowContext.apply(this, arguments);
      }

      return updateWorkflowContext;
    }()
  }, {
    key: "updateRWorkflowStateContext",
    value: function () {
      var _updateRWorkflowStateContext = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee100(state, json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee100$(_context100) {
          while (1) {
            switch (_context100.prev = _context100.next) {
              case 0:
                _context100.next = 2;
                return this.request.post("/workflows/repairstate/".concat(state), json);

              case 2:
                response = _context100.sent;
                return _context100.abrupt("return", response.data);

              case 4:
              case "end":
                return _context100.stop();
            }
          }
        }, _callee100, this);
      }));

      function updateRWorkflowStateContext(_x140, _x141) {
        return _updateRWorkflowStateContext.apply(this, arguments);
      }

      return updateRWorkflowStateContext;
    }()
  }, {
    key: "updateMWorkflowStateContext",
    value: function () {
      var _updateMWorkflowStateContext = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee101(state, json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                _context101.next = 2;
                return this.request.post("/workflows/meetingstate/".concat(state), json);

              case 2:
                response = _context101.sent;
                return _context101.abrupt("return", response.data);

              case 4:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101, this);
      }));

      function updateMWorkflowStateContext(_x142, _x143) {
        return _updateMWorkflowStateContext.apply(this, arguments);
      }

      return updateMWorkflowStateContext;
    }() // sms

  }, {
    key: "sendSmsPinByWeb",
    value: function () {
      var _sendSmsPinByWeb = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee102(mobile, pin) {
        var response;
        return _regeneratorRuntime.wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                _context102.next = 2;
                return this.request.post("/sms/pin/".concat(mobile, "/").concat(pin), {}, {
                  headers: {
                    secret: md5(mobile + pin)
                  }
                });

              case 2:
                response = _context102.sent;
                return _context102.abrupt("return", response.data);

              case 4:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102, this);
      }));

      function sendSmsPinByWeb(_x144, _x145) {
        return _sendSmsPinByWeb.apply(this, arguments);
      }

      return sendSmsPinByWeb;
    }() // phone
    // caller, called 都是手机号码

  }, {
    key: "makePhoneCall",
    value: function () {
      var _makePhoneCall = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee103(called) {
        var response;
        return _regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                _context103.next = 2;
                return this.request.post("/phone/call/".concat(called));

              case 2:
                response = _context103.sent;
                return _context103.abrupt("return", response.data);

              case 4:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103, this);
      }));

      function makePhoneCall(_x146) {
        return _makePhoneCall.apply(this, arguments);
      }

      return makePhoneCall;
    }() // numbers 都是手机号码

  }, {
    key: "makeConCall",
    value: function () {
      var _makeConCall = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee104(numbers) {
        var response;
        return _regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                _context104.next = 2;
                return this.request.post('/phone/conf', numbers);

              case 2:
                response = _context104.sent;
                return _context104.abrupt("return", response.data);

              case 4:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, this);
      }));

      function makeConCall(_x147) {
        return _makeConCall.apply(this, arguments);
      }

      return makeConCall;
    }()
  }, {
    key: "fetchedAssets",
    value: function () {
      var _fetchedAssets = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee105(type) {
        var response;
        return _regeneratorRuntime.wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                _context105.next = 2;
                return this.request.get("/assets/".concat(type));

              case 2:
                response = _context105.sent;
                return _context105.abrupt("return", response.data);

              case 4:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105, this);
      }));

      function fetchedAssets(_x148) {
        return _fetchedAssets.apply(this, arguments);
      }

      return fetchedAssets;
    }()
  }, {
    key: "createAsset",
    value: function () {
      var _createAsset = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee106(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                _context106.next = 2;
                return this.request.post('/assets', form);

              case 2:
                response = _context106.sent;
                return _context106.abrupt("return", response.data);

              case 4:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, this);
      }));

      function createAsset(_x149) {
        return _createAsset.apply(this, arguments);
      }

      return createAsset;
    }()
  }, {
    key: "updateAsset",
    value: function () {
      var _updateAsset = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee107(json) {
        var response;
        return _regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                _context107.next = 2;
                return this.request.post("/assets/".concat(json.id), json);

              case 2:
                response = _context107.sent;
                return _context107.abrupt("return", response.data);

              case 4:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107, this);
      }));

      function updateAsset(_x150) {
        return _updateAsset.apply(this, arguments);
      }

      return updateAsset;
    }()
  }, {
    key: "deleteAsset",
    value: function () {
      var _deleteAsset = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee108(id) {
        return _regeneratorRuntime.wrap(function _callee108$(_context108) {
          while (1) {
            switch (_context108.prev = _context108.next) {
              case 0:
                _context108.next = 2;
                return this.request.delete("/assets/".concat(id));

              case 2:
                return _context108.abrupt("return", _context108.sent);

              case 3:
              case "end":
                return _context108.stop();
            }
          }
        }, _callee108, this);
      }));

      function deleteAsset(_x151) {
        return _deleteAsset.apply(this, arguments);
      }

      return deleteAsset;
    }()
  }, {
    key: "fetchAssetsByRoom",
    value: function () {
      var _fetchAssetsByRoom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee109(room) {
        var response;
        return _regeneratorRuntime.wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                _context109.next = 2;
                return this.request.get("/assets/".concat(room));

              case 2:
                response = _context109.sent;
                return _context109.abrupt("return", response.data);

              case 4:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109, this);
      }));

      function fetchAssetsByRoom(_x152) {
        return _fetchAssetsByRoom.apply(this, arguments);
      }

      return fetchAssetsByRoom;
    }()
  }, {
    key: "fetchDeviceTrackByAssetId",
    value: function () {
      var _fetchDeviceTrackByAssetId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee110(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee110$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                _context110.next = 2;
                return this.request.get("/assets/device/tracks/".concat(id));

              case 2:
                response = _context110.sent;
                return _context110.abrupt("return", response.data);

              case 4:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee110, this);
      }));

      function fetchDeviceTrackByAssetId(_x153) {
        return _fetchDeviceTrackByAssetId.apply(this, arguments);
      }

      return fetchDeviceTrackByAssetId;
    }()
  }, {
    key: "createAssetDeviceTrack",
    value: function () {
      var _createAssetDeviceTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee111(id, form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                _context111.next = 2;
                return this.request.post("/assets/device/tracks/".concat(id, "/create"), form);

              case 2:
                response = _context111.sent;
                return _context111.abrupt("return", response.data);

              case 4:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, this);
      }));

      function createAssetDeviceTrack(_x154, _x155) {
        return _createAssetDeviceTrack.apply(this, arguments);
      }

      return createAssetDeviceTrack;
    }()
  }, {
    key: "updateAssetDeviceTrack",
    value: function () {
      var _updateAssetDeviceTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee112(id, form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                _context112.next = 2;
                return this.request.post("/assets/device/tracks/".concat(id, "/edit"), form);

              case 2:
                response = _context112.sent;
                return _context112.abrupt("return", response.data);

              case 4:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112, this);
      }));

      function updateAssetDeviceTrack(_x156, _x157) {
        return _updateAssetDeviceTrack.apply(this, arguments);
      }

      return updateAssetDeviceTrack;
    }()
  }, {
    key: "deleteAssetDeviceTrack",
    value: function () {
      var _deleteAssetDeviceTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee113(id, trackid) {
        var response;
        return _regeneratorRuntime.wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                _context113.next = 2;
                return this.request.post("/assets/device/tracks/".concat(id, "/delete/").concat(trackid));

              case 2:
                response = _context113.sent;
                return _context113.abrupt("return", response.data);

              case 4:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113, this);
      }));

      function deleteAssetDeviceTrack(_x158, _x159) {
        return _deleteAssetDeviceTrack.apply(this, arguments);
      }

      return deleteAssetDeviceTrack;
    }()
  }, {
    key: "fetchDevicesByRoom",
    value: function () {
      var _fetchDevicesByRoom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee114(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee114$(_context114) {
          while (1) {
            switch (_context114.prev = _context114.next) {
              case 0:
                response = ''; // if (process.env.NODE_ENV !== 'production') {
                //   let headers = {
                //     company: 'shgbit',
                //     pin: '5h1g5x2qa',
                //     room: '2C01',
                //     from: 'zhaolei@shgbit.com'
                //   }
                //   response = await axios.get(`https://pro.meeting365.com/api/devhub`, { headers });
                // } else {

                _context114.next = 3;
                return this.request.get("/rooms/".concat(id, "/dev-status"));

              case 3:
                response = _context114.sent;
                return _context114.abrupt("return", response.data);

              case 5:
              case "end":
                return _context114.stop();
            }
          }
        }, _callee114, this);
      }));

      function fetchDevicesByRoom(_x160) {
        return _fetchDevicesByRoom.apply(this, arguments);
      }

      return fetchDevicesByRoom;
    }()
  }, {
    key: "fetchTrackersByRoom",
    value: function () {
      var _fetchTrackersByRoom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee115(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee115$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                _context115.next = 2;
                return this.request.get("/rooms/".concat(id, "/trackers"));

              case 2:
                response = _context115.sent;
                return _context115.abrupt("return", response.data);

              case 4:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee115, this);
      }));

      function fetchTrackersByRoom(_x161) {
        return _fetchTrackersByRoom.apply(this, arguments);
      }

      return fetchTrackersByRoom;
    }() // 会议室信息屏幕

  }, {
    key: "fetchRoomboards",
    value: function () {
      var _fetchRoomboards = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee116(company) {
        var response;
        return _regeneratorRuntime.wrap(function _callee116$(_context116) {
          while (1) {
            switch (_context116.prev = _context116.next) {
              case 0:
                _context116.next = 2;
                return this.request.get("/screens?company=".concat(company));

              case 2:
                response = _context116.sent;
                return _context116.abrupt("return", response.data);

              case 4:
              case "end":
                return _context116.stop();
            }
          }
        }, _callee116, this);
      }));

      function fetchRoomboards(_x162) {
        return _fetchRoomboards.apply(this, arguments);
      }

      return fetchRoomboards;
    }()
  }, {
    key: "fetchRoomboardById",
    value: function () {
      var _fetchRoomboardById = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee117(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee117$(_context117) {
          while (1) {
            switch (_context117.prev = _context117.next) {
              case 0:
                _context117.next = 2;
                return this.request.get("/screens/".concat(id));

              case 2:
                response = _context117.sent;
                return _context117.abrupt("return", response.data);

              case 4:
              case "end":
                return _context117.stop();
            }
          }
        }, _callee117, this);
      }));

      function fetchRoomboardById(_x163) {
        return _fetchRoomboardById.apply(this, arguments);
      }

      return fetchRoomboardById;
    }()
  }, {
    key: "createRoomboard",
    value: function () {
      var _createRoomboard = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee118(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee118$(_context118) {
          while (1) {
            switch (_context118.prev = _context118.next) {
              case 0:
                _context118.next = 2;
                return this.request.post('/screens', form);

              case 2:
                response = _context118.sent;
                return _context118.abrupt("return", response.data);

              case 4:
              case "end":
                return _context118.stop();
            }
          }
        }, _callee118, this);
      }));

      function createRoomboard(_x164) {
        return _createRoomboard.apply(this, arguments);
      }

      return createRoomboard;
    }()
  }, {
    key: "updateRoomboards",
    value: function () {
      var _updateRoomboards = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee119(id, form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee119$(_context119) {
          while (1) {
            switch (_context119.prev = _context119.next) {
              case 0:
                _context119.next = 2;
                return this.request.post("/screens/".concat(id), form);

              case 2:
                response = _context119.sent;
                return _context119.abrupt("return", response.data);

              case 4:
              case "end":
                return _context119.stop();
            }
          }
        }, _callee119, this);
      }));

      function updateRoomboards(_x165, _x166) {
        return _updateRoomboards.apply(this, arguments);
      }

      return updateRoomboards;
    }()
  }, {
    key: "deleteRoomboard",
    value: function () {
      var _deleteRoomboard = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee120(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee120$(_context120) {
          while (1) {
            switch (_context120.prev = _context120.next) {
              case 0:
                _context120.next = 2;
                return this.request.delete("/screens/".concat(id));

              case 2:
                response = _context120.sent;
                return _context120.abrupt("return", response.data);

              case 4:
              case "end":
                return _context120.stop();
            }
          }
        }, _callee120, this);
      }));

      function deleteRoomboard(_x167) {
        return _deleteRoomboard.apply(this, arguments);
      }

      return deleteRoomboard;
    }()
  }, {
    key: "findOneFeedback",
    value: function () {
      var _findOneFeedback = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee121(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee121$(_context121) {
          while (1) {
            switch (_context121.prev = _context121.next) {
              case 0:
                _context121.next = 2;
                return this.request.get("/comments/".concat(id));

              case 2:
                response = _context121.sent;
                return _context121.abrupt("return", response.data);

              case 4:
              case "end":
                return _context121.stop();
            }
          }
        }, _callee121, this);
      }));

      function findOneFeedback(_x168) {
        return _findOneFeedback.apply(this, arguments);
      }

      return findOneFeedback;
    }()
  }, {
    key: "uploadApk",
    value: function () {
      var _uploadApk = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee122(form, id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee122$(_context122) {
          while (1) {
            switch (_context122.prev = _context122.next) {
              case 0:
                _context122.next = 2;
                return this.request.post("roomboard/upload/".concat(id), form);

              case 2:
                response = _context122.sent;
                return _context122.abrupt("return", response.data);

              case 4:
              case "end":
                return _context122.stop();
            }
          }
        }, _callee122, this);
      }));

      function uploadApk(_x169, _x170) {
        return _uploadApk.apply(this, arguments);
      }

      return uploadApk;
    }()
  }, {
    key: "addFileUpload",
    value: function () {
      var _addFileUpload = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee123(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee123$(_context123) {
          while (1) {
            switch (_context123.prev = _context123.next) {
              case 0:
                _context123.next = 2;
                return this.request.post("assets/fileUpload/create", form);

              case 2:
                response = _context123.sent;
                return _context123.abrupt("return", response.data);

              case 4:
              case "end":
                return _context123.stop();
            }
          }
        }, _callee123, this);
      }));

      function addFileUpload(_x171) {
        return _addFileUpload.apply(this, arguments);
      }

      return addFileUpload;
    }()
  }, {
    key: "findAssetFiles",
    value: function () {
      var _findAssetFiles = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee124(company) {
        var response;
        return _regeneratorRuntime.wrap(function _callee124$(_context124) {
          while (1) {
            switch (_context124.prev = _context124.next) {
              case 0:
                _context124.next = 2;
                return this.request.get("assets/files/".concat(company));

              case 2:
                response = _context124.sent;
                return _context124.abrupt("return", response.data);

              case 4:
              case "end":
                return _context124.stop();
            }
          }
        }, _callee124, this);
      }));

      function findAssetFiles(_x172) {
        return _findAssetFiles.apply(this, arguments);
      }

      return findAssetFiles;
    }()
  }, {
    key: "deleteAssetFile",
    value: function () {
      var _deleteAssetFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee125(id) {
        return _regeneratorRuntime.wrap(function _callee125$(_context125) {
          while (1) {
            switch (_context125.prev = _context125.next) {
              case 0:
                _context125.next = 2;
                return this.request.post("assets/fileUpload/delete/".concat(id));

              case 2:
                return _context125.abrupt("return", _context125.sent);

              case 3:
              case "end":
                return _context125.stop();
            }
          }
        }, _callee125, this);
      }));

      function deleteAssetFile(_x173) {
        return _deleteAssetFile.apply(this, arguments);
      }

      return deleteAssetFile;
    }()
  }, {
    key: "findFeedbacks",
    value: function () {
      var _findFeedbacks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee126() {
        var response;
        return _regeneratorRuntime.wrap(function _callee126$(_context126) {
          while (1) {
            switch (_context126.prev = _context126.next) {
              case 0:
                _context126.next = 2;
                return this.request.get('/comments');

              case 2:
                response = _context126.sent;
                return _context126.abrupt("return", response.data);

              case 4:
              case "end":
                return _context126.stop();
            }
          }
        }, _callee126, this);
      }));

      function findFeedbacks() {
        return _findFeedbacks.apply(this, arguments);
      }

      return findFeedbacks;
    }()
  }, {
    key: "createFeedback",
    value: function () {
      var _createFeedback = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee127(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee127$(_context127) {
          while (1) {
            switch (_context127.prev = _context127.next) {
              case 0:
                _context127.next = 2;
                return this.request.post('/comments', form);

              case 2:
                response = _context127.sent;
                return _context127.abrupt("return", response.data);

              case 4:
              case "end":
                return _context127.stop();
            }
          }
        }, _callee127, this);
      }));

      function createFeedback(_x174) {
        return _createFeedback.apply(this, arguments);
      }

      return createFeedback;
    }()
  }, {
    key: "updateFeedbackStatus",
    value: function () {
      var _updateFeedbackStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee128(id, status) {
        var response;
        return _regeneratorRuntime.wrap(function _callee128$(_context128) {
          while (1) {
            switch (_context128.prev = _context128.next) {
              case 0:
                _context128.next = 2;
                return this.request.post("/comments/".concat(id, "/status"), status);

              case 2:
                response = _context128.sent;
                return _context128.abrupt("return", response.data);

              case 4:
              case "end":
                return _context128.stop();
            }
          }
        }, _callee128, this);
      }));

      function updateFeedbackStatus(_x175, _x176) {
        return _updateFeedbackStatus.apply(this, arguments);
      }

      return updateFeedbackStatus;
    }()
  }, {
    key: "addComment",
    value: function () {
      var _addComment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee129(data) {
        var response;
        return _regeneratorRuntime.wrap(function _callee129$(_context129) {
          while (1) {
            switch (_context129.prev = _context129.next) {
              case 0:
                _context129.next = 2;
                return this.request.post("/comments/".concat(data.id, "/add"), data);

              case 2:
                response = _context129.sent;
                return _context129.abrupt("return", response.data);

              case 4:
              case "end":
                return _context129.stop();
            }
          }
        }, _callee129, this);
      }));

      function addComment(_x177) {
        return _addComment.apply(this, arguments);
      }

      return addComment;
    }()
  }, {
    key: "getDingtalkUser",
    value: function () {
      var _getDingtalkUser = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee130(code, appkey, appsecret) {
        var response;
        return _regeneratorRuntime.wrap(function _callee130$(_context130) {
          while (1) {
            switch (_context130.prev = _context130.next) {
              case 0:
                _context130.next = 2;
                return this.request.get("/ding/gettoken?code=".concat(code, "&appkey=").concat(appkey, "&appsecret=").concat(appsecret));

              case 2:
                response = _context130.sent;
                return _context130.abrupt("return", response.data);

              case 4:
              case "end":
                return _context130.stop();
            }
          }
        }, _callee130, this);
      }));

      function getDingtalkUser(_x178, _x179, _x180) {
        return _getDingtalkUser.apply(this, arguments);
      }

      return getDingtalkUser;
    }()
  }, {
    key: "register",
    value: function () {
      var _register = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee131(id, timespan, data) {
        var response;
        return _regeneratorRuntime.wrap(function _callee131$(_context131) {
          while (1) {
            switch (_context131.prev = _context131.next) {
              case 0:
                _context131.next = 2;
                return this.request.post("/external/meetings/".concat(id, "/").concat(timespan, "/checkin"), data);

              case 2:
                response = _context131.sent;
                return _context131.abrupt("return", response.data);

              case 4:
              case "end":
                return _context131.stop();
            }
          }
        }, _callee131, this);
      }));

      function register(_x181, _x182, _x183) {
        return _register.apply(this, arguments);
      }

      return register;
    }()
  }, {
    key: "fetchDesks",
    value: function () {
      var _fetchDesks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee132() {
        var response;
        return _regeneratorRuntime.wrap(function _callee132$(_context132) {
          while (1) {
            switch (_context132.prev = _context132.next) {
              case 0:
                _context132.next = 2;
                return this.request.get('/desks');

              case 2:
                response = _context132.sent;
                return _context132.abrupt("return", response.data);

              case 4:
              case "end":
                return _context132.stop();
            }
          }
        }, _callee132, this);
      }));

      function fetchDesks() {
        return _fetchDesks.apply(this, arguments);
      }

      return fetchDesks;
    }()
  }, {
    key: "fetchDeskBookings",
    value: function () {
      var _fetchDeskBookings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee133(begin, end) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee133$(_context133) {
          while (1) {
            switch (_context133.prev = _context133.next) {
              case 0:
                url = '/desks/reservation';

                if (begin) {
                  url += "?begin=".concat(begin.unix());

                  if (end) {
                    url += "&end=".concat(end.unix());
                  }
                }

                _context133.next = 4;
                return this.request.get(url);

              case 4:
                response = _context133.sent;
                return _context133.abrupt("return", response.data);

              case 6:
              case "end":
                return _context133.stop();
            }
          }
        }, _callee133, this);
      }));

      function fetchDeskBookings(_x184, _x185) {
        return _fetchDeskBookings.apply(this, arguments);
      }

      return fetchDeskBookings;
    }()
  }, {
    key: "fetchDesk",
    value: function () {
      var _fetchDesk = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee134(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee134$(_context134) {
          while (1) {
            switch (_context134.prev = _context134.next) {
              case 0:
                _context134.next = 2;
                return this.request.get("/desks/".concat(id, "/desk"));

              case 2:
                response = _context134.sent;
                return _context134.abrupt("return", response.data);

              case 4:
              case "end":
                return _context134.stop();
            }
          }
        }, _callee134, this);
      }));

      function fetchDesk(_x186) {
        return _fetchDesk.apply(this, arguments);
      }

      return fetchDesk;
    }()
  }, {
    key: "createBooking",
    value: function () {
      var _createBooking = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee135(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee135$(_context135) {
          while (1) {
            switch (_context135.prev = _context135.next) {
              case 0:
                _context135.next = 2;
                return this.request.post('/desks/reservation/create', form);

              case 2:
                response = _context135.sent;
                return _context135.abrupt("return", response.data);

              case 4:
              case "end":
                return _context135.stop();
            }
          }
        }, _callee135, this);
      }));

      function createBooking(_x187) {
        return _createBooking.apply(this, arguments);
      }

      return createBooking;
    }()
  }, {
    key: "updateBooking",
    value: function () {
      var _updateBooking = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee136(id, form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee136$(_context136) {
          while (1) {
            switch (_context136.prev = _context136.next) {
              case 0:
                _context136.next = 2;
                return this.request.post("/desks/reservation/".concat(id, "/edit"), form);

              case 2:
                response = _context136.sent;
                return _context136.abrupt("return", response.data);

              case 4:
              case "end":
                return _context136.stop();
            }
          }
        }, _callee136, this);
      }));

      function updateBooking(_x188, _x189) {
        return _updateBooking.apply(this, arguments);
      }

      return updateBooking;
    }()
  }, {
    key: "findDeskBooingById",
    value: function () {
      var _findDeskBooingById = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee137(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee137$(_context137) {
          while (1) {
            switch (_context137.prev = _context137.next) {
              case 0:
                _context137.next = 2;
                return this.request.get("/desks/reservation/".concat(id));

              case 2:
                response = _context137.sent;
                return _context137.abrupt("return", response.data);

              case 4:
              case "end":
                return _context137.stop();
            }
          }
        }, _callee137, this);
      }));

      function findDeskBooingById(_x190) {
        return _findDeskBooingById.apply(this, arguments);
      }

      return findDeskBooingById;
    }()
  }, {
    key: "deleteBooking",
    value: function () {
      var _deleteBooking = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee138(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee138$(_context138) {
          while (1) {
            switch (_context138.prev = _context138.next) {
              case 0:
                _context138.next = 2;
                return this.request.post("/desks/reservation/".concat(id, "/delete"));

              case 2:
                response = _context138.sent;
                return _context138.abrupt("return", response.data);

              case 4:
              case "end":
                return _context138.stop();
            }
          }
        }, _callee138, this);
      }));

      function deleteBooking(_x191) {
        return _deleteBooking.apply(this, arguments);
      }

      return deleteBooking;
    }()
  }, {
    key: "createDesk",
    value: function () {
      var _createDesk = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee139(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee139$(_context139) {
          while (1) {
            switch (_context139.prev = _context139.next) {
              case 0:
                _context139.next = 2;
                return this.request.post('/desks/create', form);

              case 2:
                response = _context139.sent;
                return _context139.abrupt("return", response.data);

              case 4:
              case "end":
                return _context139.stop();
            }
          }
        }, _callee139, this);
      }));

      function createDesk(_x192) {
        return _createDesk.apply(this, arguments);
      }

      return createDesk;
    }()
  }, {
    key: "deleteDesk",
    value: function () {
      var _deleteDesk = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee140(id) {
        return _regeneratorRuntime.wrap(function _callee140$(_context140) {
          while (1) {
            switch (_context140.prev = _context140.next) {
              case 0:
                _context140.next = 2;
                return this.request.post("/desks/delete/".concat(id));

              case 2:
                return _context140.abrupt("return", _context140.sent);

              case 3:
              case "end":
                return _context140.stop();
            }
          }
        }, _callee140, this);
      }));

      function deleteDesk(_x193) {
        return _deleteDesk.apply(this, arguments);
      }

      return deleteDesk;
    }()
  }, {
    key: "updateDesk",
    value: function () {
      var _updateDesk = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee141(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee141$(_context141) {
          while (1) {
            switch (_context141.prev = _context141.next) {
              case 0:
                _context141.next = 2;
                return this.request.post("/desks/update/".concat(form.id), form);

              case 2:
                response = _context141.sent;
                return _context141.abrupt("return", response.data);

              case 4:
              case "end":
                return _context141.stop();
            }
          }
        }, _callee141, this);
      }));

      function updateDesk(_x194) {
        return _updateDesk.apply(this, arguments);
      }

      return updateDesk;
    }()
  }, {
    key: "fetchedReports",
    value: function () {
      var _fetchedReports = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee142() {
        var response;
        return _regeneratorRuntime.wrap(function _callee142$(_context142) {
          while (1) {
            switch (_context142.prev = _context142.next) {
              case 0:
                _context142.next = 2;
                return this.request.get('/reports');

              case 2:
                response = _context142.sent;
                return _context142.abrupt("return", response.data);

              case 4:
              case "end":
                return _context142.stop();
            }
          }
        }, _callee142, this);
      }));

      function fetchedReports() {
        return _fetchedReports.apply(this, arguments);
      }

      return fetchedReports;
    }()
  }, {
    key: "createReport",
    value: function () {
      var _createReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee143(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee143$(_context143) {
          while (1) {
            switch (_context143.prev = _context143.next) {
              case 0:
                _context143.next = 2;
                return this.request.post('/reports', form);

              case 2:
                response = _context143.sent;
                return _context143.abrupt("return", response.data);

              case 4:
              case "end":
                return _context143.stop();
            }
          }
        }, _callee143, this);
      }));

      function createReport(_x195) {
        return _createReport.apply(this, arguments);
      }

      return createReport;
    }()
  }, {
    key: "deleteRepeatMeetings",
    value: function () {
      var _deleteRepeatMeetings2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee144(id) {
        return _regeneratorRuntime.wrap(function _callee144$(_context144) {
          while (1) {
            switch (_context144.prev = _context144.next) {
              case 0:
                _context144.next = 2;
                return this.request.delete("/meetings/repeat/".concat(id));

              case 2:
                return _context144.abrupt("return", _context144.sent);

              case 3:
              case "end":
                return _context144.stop();
            }
          }
        }, _callee144, this);
      }));

      function deleteRepeatMeetings(_x196) {
        return _deleteRepeatMeetings2.apply(this, arguments);
      }

      return deleteRepeatMeetings;
    }()
  }, {
    key: "cancelRepeatMeeting",
    value: function () {
      var _cancelRepeatMeeting2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee145(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee145$(_context145) {
          while (1) {
            switch (_context145.prev = _context145.next) {
              case 0:
                _context145.next = 2;
                return this.request.post("/meetings/repeat/".concat(id, "/cancel"), null);

              case 2:
                response = _context145.sent;
                return _context145.abrupt("return", response.data);

              case 4:
              case "end":
                return _context145.stop();
            }
          }
        }, _callee145, this);
      }));

      function cancelRepeatMeeting(_x197) {
        return _cancelRepeatMeeting2.apply(this, arguments);
      }

      return cancelRepeatMeeting;
    }()
  }, {
    key: "getRoomsQuery",
    value: function () {
      var _getRoomsQuery = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee146(company, area, device, capacity, roomType, key, sort, page, size) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee146$(_context146) {
          while (1) {
            switch (_context146.prev = _context146.next) {
              case 0:
                url = "/rooms/query?company=".concat(company);

                if (area) {
                  url += "&area=".concat(area);
                }

                if (key) {
                  url += "&key=".concat(key);
                }

                if (sort) {
                  url += "&sort=".concat(sort);
                }

                if (page) {
                  url += "&page=".concat(page);
                }

                if (device) {
                  url += "&device=".concat(device);
                }

                if (capacity) {
                  url += "&capacity=".concat(capacity);
                }

                if (roomType) {
                  url += "&roomType=".concat(roomType);
                }

                if (size) {
                  url += "&size=".concat(size);
                }

                _context146.next = 11;
                return this.request.get(url);

              case 11:
                response = _context146.sent;
                return _context146.abrupt("return", response.data);

              case 13:
              case "end":
                return _context146.stop();
            }
          }
        }, _callee146, this);
      }));

      function getRoomsQuery(_x198, _x199, _x200, _x201, _x202, _x203, _x204, _x205, _x206) {
        return _getRoomsQuery.apply(this, arguments);
      }

      return getRoomsQuery;
    }()
  }, {
    key: "getMembersQuery",
    value: function () {
      var _getMembersQuery = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee147(company, dept, key, sort, page, size) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee147$(_context147) {
          while (1) {
            switch (_context147.prev = _context147.next) {
              case 0:
                url = "/members/query?company=".concat(company);

                if (dept) {
                  url += "&dept=".concat(dept);
                }

                if (key) {
                  url += "&key=".concat(key);
                }

                if (sort) {
                  url += "&sort=".concat(sort);
                }

                if (page) {
                  url += "&page=".concat(page);
                }

                if (size) {
                  url += "&size=".concat(size);
                }

                _context147.next = 8;
                return this.request.get(url);

              case 8:
                response = _context147.sent;
                return _context147.abrupt("return", response.data);

              case 10:
              case "end":
                return _context147.stop();
            }
          }
        }, _callee147, this);
      }));

      function getMembersQuery(_x207, _x208, _x209, _x210, _x211, _x212) {
        return _getMembersQuery.apply(this, arguments);
      }

      return getMembersQuery;
    }()
  }, {
    key: "getMeetingsQuery",
    value: function () {
      var _getMeetingsQuery = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee148(company, location, begin, end, page, key, sort, user, size) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee148$(_context148) {
          while (1) {
            switch (_context148.prev = _context148.next) {
              case 0:
                url = "/meetings/query?company=".concat(company);

                if (location) {
                  url += "&location=".concat(location);
                }

                if (begin) {
                  url += "&begin=".concat(begin.unix());
                }

                if (end) {
                  url += "&end=".concat(end.unix());
                }

                if (user) {
                  url += "&user=".concat(user);
                }

                if (key) {
                  url += "&key=".concat(key);
                }

                if (sort) {
                  url += "&sort=".concat(sort);
                }

                if (page) {
                  url += "&page=".concat(page);
                }

                if (size) {
                  url += "&size=".concat(size);
                }

                _context148.next = 11;
                return this.request.get(url);

              case 11:
                response = _context148.sent;
                return _context148.abrupt("return", response.data);

              case 13:
              case "end":
                return _context148.stop();
            }
          }
        }, _callee148, this);
      }));

      function getMeetingsQuery(_x213, _x214, _x215, _x216, _x217, _x218, _x219, _x220, _x221) {
        return _getMeetingsQuery.apply(this, arguments);
      }

      return getMeetingsQuery;
    }()
  }, {
    key: "getMeetingsAnalyse",
    value: function () {
      var _getMeetingsAnalyse = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee149(company, location, begin, end, page, key, sort, user) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee149$(_context149) {
          while (1) {
            switch (_context149.prev = _context149.next) {
              case 0:
                url = "/meetings/analyse?company=".concat(company);

                if (location) {
                  url += "&location=".concat(location);
                }

                if (begin) {
                  url += "&begin=".concat(begin.unix());
                }

                if (end) {
                  url += "&end=".concat(end.unix());
                }

                if (user) {
                  url += "&user=".concat(user);
                }

                if (key) {
                  url += "&key=".concat(key);
                }

                if (sort) {
                  url += "&sort=".concat(sort);
                }

                if (page) {
                  url += "&page=".concat(page);
                }

                _context149.next = 10;
                return this.request.get(url);

              case 10:
                response = _context149.sent;
                return _context149.abrupt("return", response.data);

              case 12:
              case "end":
                return _context149.stop();
            }
          }
        }, _callee149, this);
      }));

      function getMeetingsAnalyse(_x222, _x223, _x224, _x225, _x226, _x227, _x228, _x229) {
        return _getMeetingsAnalyse.apply(this, arguments);
      }

      return getMeetingsAnalyse;
    }()
  }, {
    key: "createVCMeeting",
    value: function () {
      var _createVCMeeting = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee150(data) {
        var response;
        return _regeneratorRuntime.wrap(function _callee150$(_context150) {
          while (1) {
            switch (_context150.prev = _context150.next) {
              case 0:
                _context150.next = 2;
                return this.request.post("/vc-meetings", data);

              case 2:
                response = _context150.sent;
                return _context150.abrupt("return", response.data);

              case 4:
              case "end":
                return _context150.stop();
            }
          }
        }, _callee150, this);
      }));

      function createVCMeeting(_x230) {
        return _createVCMeeting.apply(this, arguments);
      }

      return createVCMeeting;
    }()
  }, {
    key: "editVCMeeting",
    value: function () {
      var _editVCMeeting = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee151(data) {
        var response;
        return _regeneratorRuntime.wrap(function _callee151$(_context151) {
          while (1) {
            switch (_context151.prev = _context151.next) {
              case 0:
                _context151.next = 2;
                return this.request.post("/vc-meetings/".concat(data._id), data);

              case 2:
                response = _context151.sent;
                return _context151.abrupt("return", response.data);

              case 4:
              case "end":
                return _context151.stop();
            }
          }
        }, _callee151, this);
      }));

      function editVCMeeting(_x231) {
        return _editVCMeeting.apply(this, arguments);
      }

      return editVCMeeting;
    }()
  }, {
    key: "deleteVCMeeting",
    value: function () {
      var _deleteVCMeeting = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee152(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee152$(_context152) {
          while (1) {
            switch (_context152.prev = _context152.next) {
              case 0:
                _context152.next = 2;
                return this.request.delete("/vc-meetings/".concat(id));

              case 2:
                response = _context152.sent;
                return _context152.abrupt("return", response.data);

              case 4:
              case "end":
                return _context152.stop();
            }
          }
        }, _callee152, this);
      }));

      function deleteVCMeeting(_x232) {
        return _deleteVCMeeting.apply(this, arguments);
      }

      return deleteVCMeeting;
    }()
  }, {
    key: "findVCMeetingByVCId",
    value: function () {
      var _findVCMeetingByVCId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee153(vcId) {
        var response;
        return _regeneratorRuntime.wrap(function _callee153$(_context153) {
          while (1) {
            switch (_context153.prev = _context153.next) {
              case 0:
                _context153.next = 2;
                return this.request.get("/vc-meetings/vcId/".concat(vcId));

              case 2:
                response = _context153.sent;
                return _context153.abrupt("return", response.data);

              case 4:
              case "end":
                return _context153.stop();
            }
          }
        }, _callee153, this);
      }));

      function findVCMeetingByVCId(_x233) {
        return _findVCMeetingByVCId.apply(this, arguments);
      }

      return findVCMeetingByVCId;
    }()
  }, {
    key: "getVCMeetingsQuery",
    value: function () {
      var _getVCMeetingsQuery = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee154(company, userId, begin, end, key, sort, page, size) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee154$(_context154) {
          while (1) {
            switch (_context154.prev = _context154.next) {
              case 0:
                url = "/vc-meetings/query?company=".concat(company);

                if (userId) {
                  url += "&userId=".concat(userId);
                }

                if (begin) {
                  url += "&begin=".concat(begin.unix());
                }

                if (end) {
                  url += "&end=".concat(end.unix());
                }

                if (key) {
                  url += "&key=".concat(key);
                }

                if (page) {
                  url += "&page=".concat(page);
                }

                if (sort) {
                  url += "&sort=".concat(sort);
                }

                if (size) {
                  url += "&size=".concat(size);
                }

                _context154.next = 10;
                return this.request.get(url);

              case 10:
                response = _context154.sent;
                return _context154.abrupt("return", response.data);

              case 12:
              case "end":
                return _context154.stop();
            }
          }
        }, _callee154, this);
      }));

      function getVCMeetingsQuery(_x234, _x235, _x236, _x237, _x238, _x239, _x240, _x241) {
        return _getVCMeetingsQuery.apply(this, arguments);
      }

      return getVCMeetingsQuery;
    }()
  }, {
    key: "getBlogs",
    value: function () {
      var _getBlogs = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee155() {
        var response;
        return _regeneratorRuntime.wrap(function _callee155$(_context155) {
          while (1) {
            switch (_context155.prev = _context155.next) {
              case 0:
                _context155.next = 2;
                return this.request.get('/blog');

              case 2:
                response = _context155.sent;
                return _context155.abrupt("return", response.data);

              case 4:
              case "end":
                return _context155.stop();
            }
          }
        }, _callee155, this);
      }));

      function getBlogs() {
        return _getBlogs.apply(this, arguments);
      }

      return getBlogs;
    }()
  }, {
    key: "getBlog",
    value: function () {
      var _getBlog = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee156(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee156$(_context156) {
          while (1) {
            switch (_context156.prev = _context156.next) {
              case 0:
                _context156.next = 2;
                return this.request.get("/blog/".concat(id));

              case 2:
                response = _context156.sent;
                return _context156.abrupt("return", response.data);

              case 4:
              case "end":
                return _context156.stop();
            }
          }
        }, _callee156, this);
      }));

      function getBlog(_x242) {
        return _getBlog.apply(this, arguments);
      }

      return getBlog;
    }()
  }, {
    key: "createBlog",
    value: function () {
      var _createBlog = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee157(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee157$(_context157) {
          while (1) {
            switch (_context157.prev = _context157.next) {
              case 0:
                _context157.next = 2;
                return this.request.post('/blog', form);

              case 2:
                response = _context157.sent;
                return _context157.abrupt("return", response.data);

              case 4:
              case "end":
                return _context157.stop();
            }
          }
        }, _callee157, this);
      }));

      function createBlog(_x243) {
        return _createBlog.apply(this, arguments);
      }

      return createBlog;
    }()
  }, {
    key: "updateBlog",
    value: function () {
      var _updateBlog = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee158(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee158$(_context158) {
          while (1) {
            switch (_context158.prev = _context158.next) {
              case 0:
                _context158.next = 2;
                return this.request.post("/blog/".concat(form.id), form);

              case 2:
                response = _context158.sent;
                return _context158.abrupt("return", response.data);

              case 4:
              case "end":
                return _context158.stop();
            }
          }
        }, _callee158, this);
      }));

      function updateBlog(_x244) {
        return _updateBlog.apply(this, arguments);
      }

      return updateBlog;
    }()
  }, {
    key: "deleteBlog",
    value: function () {
      var _deleteBlog = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee159(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee159$(_context159) {
          while (1) {
            switch (_context159.prev = _context159.next) {
              case 0:
                _context159.next = 2;
                return this.request.delete("/blog/".concat(id));

              case 2:
                response = _context159.sent;
                return _context159.abrupt("return", response.data);

              case 4:
              case "end":
                return _context159.stop();
            }
          }
        }, _callee159, this);
      }));

      function deleteBlog(_x245) {
        return _deleteBlog.apply(this, arguments);
      }

      return deleteBlog;
    }()
  }, {
    key: "lang",
    value: function () {
      var _lang = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee160(form) {
        var response;
        return _regeneratorRuntime.wrap(function _callee160$(_context160) {
          while (1) {
            switch (_context160.prev = _context160.next) {
              case 0:
                _context160.next = 2;
                return this.request.post('/oauth/lang', form);

              case 2:
                response = _context160.sent;
                return _context160.abrupt("return", response.data);

              case 4:
              case "end":
                return _context160.stop();
            }
          }
        }, _callee160, this);
      }));

      function lang(_x246) {
        return _lang.apply(this, arguments);
      }

      return lang;
    }()
  }, {
    key: "getEnvServerData",
    value: function () {
      var _getEnvServerData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee161() {
        var response;
        return _regeneratorRuntime.wrap(function _callee161$(_context161) {
          while (1) {
            switch (_context161.prev = _context161.next) {
              case 0:
                _context161.next = 2;
                return this.request.get('msserver');

              case 2:
                response = _context161.sent;
                return _context161.abrupt("return", response.data);

              case 4:
              case "end":
                return _context161.stop();
            }
          }
        }, _callee161, this);
      }));

      function getEnvServerData() {
        return _getEnvServerData.apply(this, arguments);
      }

      return getEnvServerData;
    }()
  }, {
    key: "getEnvRealtimeData",
    value: function () {
      var _getEnvRealtimeData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee162() {
        var response;
        return _regeneratorRuntime.wrap(function _callee162$(_context162) {
          while (1) {
            switch (_context162.prev = _context162.next) {
              case 0:
                _context162.next = 2;
                return this.request.get('/msserver/realtime');

              case 2:
                response = _context162.sent;
                return _context162.abrupt("return", response.data);

              case 4:
              case "end":
                return _context162.stop();
            }
          }
        }, _callee162, this);
      }));

      function getEnvRealtimeData() {
        return _getEnvRealtimeData.apply(this, arguments);
      }

      return getEnvRealtimeData;
    }()
  }]);

  return TransportLayer;
}();

export { TransportLayer as default };